import type { TOA } from '@setplex/tria-api'
import { replaceTokens } from '~/shared/helpers/array'
import { formatExpirationDate } from '~/shared/helpers/date'

export const formatToa = (toa: TOA | null) => {
  if (!toa) return null

  const { tokens, message, subject } = toa

  if (tokens) {
    const formattedTokens = formatToaTokens(tokens)

    return {
      ...toa,
      message: replaceTokens(message, formattedTokens),
      subject: replaceTokens(subject, formattedTokens),
    }
  }
  return toa
}

export const formatToaTokens = (tokens: Record<string, string>) => {
  const { $expirationDate } = tokens

  if ($expirationDate) {
    return {
      ...tokens,
      $expirationDate: formatExpirationDate($expirationDate),
    }
  }

  return tokens
}
